import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useHotelData = () => {
    const getHotelData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}hotel${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postHotelData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}hotel${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}hotel${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putHotelData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}hotel${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchHotelData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}hotel${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteHotelData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}hotel${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getHotelData,
        postHotelData,
        putHotelData,
        patchHotelData,
        deleteHotelData
    };

};